module.exports = __webpack_public_path__ + "static/media/squirrel03b.74db50c7.png";